/**
 * New User Voucher Pop-up
 */
import React, { useState, useEffect } from 'react';
import Loading from '@ali/infinite-webui/es/web-components/Loading';
import Button from '../Button/index-pc';
import Banner from '../Banner/index-pc';
import Content from '../Content/nu-index-pc';
import Toast from '@ali/infinite-webui/es/web-components/Toast';
import { cls } from '../../utils';
import { subscribe } from '../../server';
import SubscribePopup, { ShowConfig } from '../../index-pc';
import Timer from '../../baseComps/Timer';
import Voucher from '../../baseComps/Voucher-pc';
import { getVoucher } from '../../server/request';
import { statusCode } from '../../const';
import { getNuPopupJumpLand } from '../../server/request';
import Styles from './nu-index-pc.module.scss';

const LoadingEle: any = Loading.Element;

function Container(
  props: ShowConfig,
  ref?: React.MutableRefObject<HTMLDivElement>
) {
  const { data, userTrack } = props;
  const { spmc, trackingParam, clickArgs, exposeArgs, spmd } = userTrack || {};
  const {
    title,
    explanation,
    headerImageUrl,
    backgroundColor,
    closeImageUrl,
    email,
    targetUrl,
    type,
    subscribeParam,
    successToast,
    failureToast,
    closeBtnText,
    tc,
    voucher = {},
  } = data || {};
  const {
    voucherStatus,
    pop,
    config,
    logInTitle,
    countdown = {},
    collectBtnText,
    collectedBtnText,
  } = voucher.ticket || {};

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(
    voucherStatus === 'COLLECTED' ? statusCode.collected : statusCode.default
  );
  const [collectResult, setCollectResult] = useState<string>();

  const btnClick = async () => {
    setLoading(true);
    switch (!!voucherStatus) {
      case true:
        getVoucher(58006, 'pc', JSON.stringify(config))
          .then((resp) => {
            const { showToastMsg, collectResult } = resp || {};
            if (!resp?.isLoginIn) {
              setLoading(false);
              sessionStorage.setItem('nuPopup_jump_land', JSON.stringify(props));
              window.jsapi.login.show('signUp', null, logInTitle);
              window.jsapi.login.onClose(() => {
                if (document.cookie.indexOf('lzd_uid=')===-1) { 
                  getNuPopupJumpLand();
                }
              });
              return;
            }
            if (resp?.success) {
              showToastMsg &&
                Toast.show({ icon: 'success', content: resp.toastMsg });
            } else {
              showToastMsg &&
                Toast.show({ icon: 'error', content: resp.toastMsg });
            }
            collectResult && setCollectResult(collectResult);
            collectResult && setStatus(statusCode.collectResult);
          })
          .catch((e) => {
            const errorMessage = e?.errorCode?.displayMessage;
            if (errorMessage)
              Toast.show({ icon: 'error', content: errorMessage });
          });
        break;

      default:
        if (type === 'SUBSCRIPTION' && email) {
          const res = await subscribe(subscribeParam);
          if (res && res.data.status === 1) {
            Toast.show(successToast);
            SubscribePopup.close();
          } else {
            Toast.show(failureToast);
          }
        } else if (targetUrl && !email) {
          window.location.href = targetUrl;
        }
        break;
    }
    setLoading(false);
  };

  const statusClick = () => {
    const {
      collectedType,
      url,
      tcBtnText,
      collectedDescription,
      termsAndConditions,
    } = pop || {};

    if (collectedType === 'description') {
      if (window.jsapi?.promotion?.aboutCoupon) {
        window.jsapi.promotion.aboutCoupon({
          aboutCouponDialog: {
            visible: true,
            title: collectedDescription.title,
            subTitle: collectedDescription.subTC[0].title,
            contents: collectedDescription.subTC[0].subTC,
            buttonTxt: tcBtnText,
          },
          termsAndConditionsDialog: {
            visible: false,
            title: tcBtnText,
            contents: termsAndConditions,
          },
        });
      }
    } else if (collectedType === 'addon') {
      window.location.href = url;
    }
  };

  useEffect(() => {
    if (getNuPopupJumpLand() && ~document.cookie.indexOf('lzd_uid=')) {
      btnClick();
    }
  }, []);

  return (
    <div
      className={cls([Styles.wrap, 'auto-c'])}
      data-params-exp={JSON.stringify(exposeArgs)}
      data-params-clk={JSON.stringify(clickArgs)}
      data-spm={spmc}
      trackingParam={JSON.stringify(trackingParam)}
    >
      <div
        className={Styles.container}
        ref={ref}
        style={{
          backgroundColor,
        }}
      >
        <Banner
          url={headerImageUrl}
          title={title}
          closeImageUrl={closeImageUrl}
          type={type}
        />
        <div className={Styles.main}>
          <Content explanation={explanation} />
          <div className={Styles.mainVoucher}>
            <div className={Styles.mainItem}>
              <Voucher data={voucher} collectResult={collectResult} />
            </div>
            {status === statusCode.collected && (
              <div className={Styles.mainTimer}>
                {countdown.countdownDay > 3 ? (
                  <span
                    className={cls([
                      'hp-countTimeTxt one-line-clamp',
                      Styles.mainTimerText,
                    ])}
                  >{`${countdown.prefixText} ${countdown.countdownDay} ${countdown.dayText}`}</span>
                ) : (
                  <Timer
                    countDown={{
                      serverTS: 0,
                      endTS: countdown.todayEndTS,
                      prefixText: countdown.prefixText,
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <Button
          btnText={collectBtnText}
          closeBtnText={closeBtnText}
          btnClick={btnClick}
          tc={tc}
          type={type}
          statusCode={status}
          statusClick={statusClick}
          howToUse={collectedBtnText}
          userTrack={userTrack}
        />
      </div>
      <LoadingEle visible={loading} mask />
    </div>
  );
}

export default React.forwardRef(Container);
